import Notifier from 'common/helpers/Notifier';

function notify({ message = '', status = '' }) {
  return (dispatch) => Notifier.dispatch(status, message, dispatch);
}

export default notify;
